import { SET_APPOINTMENT_DETAILS, RESET_RESPONSE_APPOINTMENT, FETCH_APPOINTMENT_DETAILS } from "./types";

export function setAppointmentDetails(data) {
  return {
    type: SET_APPOINTMENT_DETAILS,
    payload: data,
  };
}
export function fetchAppointmentDetails(data) {
  return {
    type: FETCH_APPOINTMENT_DETAILS,
    payload: data,
  };
}
export function resetAppointmentDetails() {
  return { type: RESET_RESPONSE_APPOINTMENT };
}
